module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_8004.03d704f6.png";